import themes from '@components/Widgets/Templates/Themes/all';

export default {
  namespaced: true,
  state: () => ({
    themes, // Contains all theme templates
  }),
  getters: {
    getThemeTemplate: (state) => (themeName) => {
      return state.themes[themeName];
    },
    getAllThemeTemplates(state) {
      return state.themes;
    },
  },
};
